import TwoFaTemplate from '~plugins/twoFa/TwoFaTemplate.vue'
import store from '~store/store'
import { i18n } from '~src/i18n'
import { getVuetifyInstance } from '../vuetify'

export default {
  install(Vue) {
    const Constructor = Vue.extend(TwoFaTemplate)
    let instance = null
    function destroyInstance() {
      instance.$destroy()
      if (instance.$el && instance.$el.parentNode) {
        instance.$el.parentNode.removeChild(instance.$el)
      }
      instance = null
    }
    Vue.verify2Fa = Vue.prototype.$verify2Fa = config => {
      const vuetify = getVuetifyInstance()
      return new Promise((resolve, reject) => {
        if (instance) return
        instance = new Constructor({
          store,
          i18n,
          vuetify
        })
        instance.$mount()
        instance.$on('confirm', () => {
          destroyInstance()
          resolve()
        })

        instance.$on('cancel', () => {
          destroyInstance()
          reject()
        })

        instance.$on('close', () => {
          destroyInstance()
          reject()
        })

        instance.open = true
        document.body.appendChild(instance.$el)
      })
    }
  }
}
